exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".addEmail[data-v-56a98574] .surecon{width:7.12rem!important;margin:auto}.addEmail[data-v-56a98574] .el-form-item__label{font-size:.266667rem!important;font-family:Arial Rounded MT Bold;color:#333;float:none}.addEmail .AE-tip[data-v-56a98574]{width:7.12rem}", ""]);

// exports
